import { db } from "./initFirebase";
import { USERS } from "../utils/consts";
const users = db.collection(USERS);
export const fetchArtists = async (artistList) => {
  let usersList = [];
  for (let artist of artistList) {
    const res = users.doc(artist.userId);
    const user = await res.get();
    usersList.push({
      ...user.data(),
      id: user.id,
    });
  }

  return usersList;
};



// WEBPACK FOOTER //
// ./src/firebase/artists.js